if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"sbg_evo","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(4(133|217|547|89)|5(2(61|7|99)|051|443|599|735|903)|6(255|747|909)|7(81(|5)|191|20|389|485|539|582)|8(019|203|395|707)|1[27]29|(27|32)77|2805|3631|9291|9553)$/.test(chunkId)},
		rootOutputDir: "",
		bundlerRuntimeOptions: { remotes: { remoteInfos: {}, webpackRequire: __webpack_require__,idToRemoteMap: {}, chunkMapping: {},idToExternalAndNameMapping: {} } }
	};
__webpack_require__.consumesLoadingData = {}
__webpack_require__.remotesLoadingData = {}
}